
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";

import Chart from "chart.js";
import { Pie, Doughnut, mixins } from "vue-chartjs";
import { IAmountByCategory } from "@/types/amount_by_category";
import { ISite } from "@/types/site";
import * as palette from "google-palette";

@Component({})
export default class CostChartComponent extends Mixins(
  Pie,
  Doughnut,
  mixins.reactiveProp
) {
  @Action("site/get")
  public getSite!: (id: number) => void;

  @Action("site/amount")
  public getAmount!: (id: number) => void;

  @Action("site/amountByCategory")
  public getAmountByCategory!: (id: number) => void;

  @Getter("site/single")
  public site!: ISite;

  @Getter("site/amount")
  public amount!: number;

  @Getter("site/byCategory")
  public amountByCategory!: IAmountByCategory[];

  @Mutation("site/clear")
  public clearSite!: () => void;

  @Prop({ default: null })
  public chartOptions!: Chart.ChartOptions;

  @Watch("chartData")
  onChartDataChanged() {
    this.load();
  }
  @Watch("addPlugin")
  onAddPluginChanged() {
    this.load();
  }
  public site_id = 0;

  public async mounted() {
    this.site_id = Number(this.$route.params.site_id);
    this.clearSite();

    this.getAmountByCategory(this.site_id);
    await Promise.all([
      this.getSite(this.site_id),
      this.getAmount(this.site_id)
    ]);
    this.setChartLabels();
    this.setChartDatas();
    this.setChartColor();
    this.addPlugin({
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      afterDraw(chart: any) {
        const ctx = chart.ctx;
        chart.data.datasets.forEach((dataset: any, i: number) => {
          let dataSum = 0;
          /* eslint-disable  @typescript-eslint/no-explicit-any */
          dataset.data.forEach((element: any) => {
            dataSum += element;
          });

          const meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
            meta.data.forEach(function(element: any, index: number) {
              // フォントの設定
              const fontSize = 10;
              const fontStyle = "bold";
              const fontFamily = "Helvetica Neue";
              ctx.fillStyle = "#000";
              // 設定を適用
              ctx.font = Chart.helpers.fontString(
                fontSize,
                fontStyle,
                fontFamily
              );

              // ラベルをパーセント表示に変更
              //   let labelString = chart.data.labels[index];
              // const labelString =
              //   `${chart.data.labels[index]}: ${dataset.data[index]}` + "円";
              // const dataString =
              //   Math.round((dataset.data[index] / dataSum) * 100).toString() +
              //   "%";
              const labelString =
                `${chart.data.labels[index]}: ${Math.round(
                  (dataset.data[index] / dataSum) * 100
                ).toString()}` + "%";
              const dataString = `${dataset.data[index]}` + "円";

              // positionの設定
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";

              const padding = -2;
              const position = element.tooltipPosition();
              // ツールチップに変更内容を表示
              ctx.fillText(
                labelString,
                position.x,
                position.y - fontSize / 2 - padding - 10
              ); // title
              ctx.fillText(
                dataString,
                position.x,
                position.y + fontSize / 2 - padding
              ); // データの百分率
            });
          }
        });
      }
    });
    this.renderChart(this.chartData, this.chartOptions);
  }
  public setChartLabels() {
    if (this.amountByCategory.length > 0) {
      this.chartData.labels = this.amountByCategory.map(
        amountByCategory => amountByCategory.name
      );
    }
  }
  public setChartDatas() {
    if (this.amountByCategory.length > 0) {
      if (!this.chartData.datasets) {
        return;
      }
      this.chartData.datasets[0].data = this.amountByCategory.map(
        amountByCategory => amountByCategory.amount
      );
    }
  }
  public setChartColor() {
    if (this.amountByCategory.length > 0) {
      if (!this.chartData.datasets) {
        return;
      }
      this.chartData.datasets[0].backgroundColor = palette(
        "mpn65",
        this.amountByCategory.length
      ).map(function(hex: string) {
        return "#" + hex;
      });
    }
  }

  load() {
    this.renderChart(this.chartData, this.chartOptions);
  }
}
